/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcDtcFilesV1FileRequestState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_DTC_FILES_V1_FILE_REQUEST_STATE_ENTITY_NAME = 'exc.dtc.files.v1.FileRequest';
export const excDtcFilesV1FileRequestStateEntity = new schema.Entity<ExcDtcFilesV1FileRequestState>(EXC_DTC_FILES_V1_FILE_REQUEST_STATE_ENTITY_NAME, {}, { idAttribute: 'fileRequestId' });

